import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";
import styles from "./Footer.module.scss";
import { HYPERPURE_HELPLINE_NUMBER } from "../../../utils/constants/others";
import apiEndpoint from "config/api.config";
import { API_HOST_HP } from "config/api.config";
class Footer extends React.Component {
  openNewWebsite = () => {
    let expireDate = new Date();
    expireDate.setFullYear(expireDate.getFullYear() + 1);

    document.cookie =
      "RouterCookie=v1;expires=" + expireDate.toUTCString() + ";path=/";
    axios({
      url: window.location.origin + "/",
      headers: {
        Pragma: "no-cache",
        Expires: -1,
      },
    }).then(() => {
      document.cookie =
        "RouterCookie=v1;expires=" + expireDate.toUTCString() + ";path=/";
      window.location.replace("https://www.hyperpure.com/");
    });
  };

  sendTrackingIdForSocialMedia = (type) => {
    let params = {
      ActionType: "CLICK",
      Element: "SOCIAL_MEDIA_LINKS",
      ReferenceId: 0,
      ReferenceType: type,
      Source: !this.props.isAuthenticated ? "FOOTER_LOG_OUT" : "FOOTER_LOG_IN",
    };
  };

  render() {
    const searchParam = queryString.parse(window.location.search);
    const isMobScreenSize = window.outerWidth < 992 ? true : false;
    if (
      (searchParam.source === "app" && isMobScreenSize) ||
      searchParam.source === "webOnboardingPage" ||
      searchParam.offer === "false" ||
      window.location.pathname.includes("/a/links/") ||
      window.location.pathname.includes("/z/links/")
    ) {
      return null;
    }

    return (
      <footer className={styles.footer}>
        {isMobScreenSize ? (
          <div className={`container footer-container-top`}>
            <div className="row d-flex justify-content-center align-items-center">
              <div>
                <div className={styles.textIcon}>
                  <div className="text-align-right">
                    <img
                      className={styles.hpIcon}
                      src="/logos/hplogo.svg"
                      alt="HP icon"
                    />
                  </div>

                  <div className="text-align-right">
                    <img
                      src="/logos/logo_hp_black.png "
                      alt="Logo"
                      className={styles.hpTextIcon}
                    />
                  </div>
                </div>
              </div>
              <div className="line-light"></div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div
          className={`container footer-container ${styles.content} fs-14 mb-30px`}
        >
          <div className="d-flex justify-content-between">
            <div className="row wd-100">
              <div className={styles.companyDetails}>
                <div>
                  <div className="fs-14 w-600 mb-12px">Company</div>
                  <div className="w-400 mb-4px">
                    Zomato Hyperpure Private Limited
                  </div>
                  <div className="text-cool-gray-600 mb-4px w-400">
                    Ground Floor, 12A, 94 Meghdoot, Nehru Place, New Delhi -
                    110019{" "}
                  </div>
                  <div className="text-cool-gray-600 mb-12px w-400">
                    CIN: U74900DL2015PTC286208
                  </div>
                  <div className="d-flex align-items-center mb-12px">
                    <img
                      className={styles.phoneIcon}
                      src="/logos/call_logo.svg"
                      alt="Phone icon"
                    />
                    {HYPERPURE_HELPLINE_NUMBER}
                  </div>

                  <div className="d-flex align-items-center mb-12px">
                    <img
                      className={styles.mailIcon}
                      src="/logos/mailFooter.png"
                      alt="Mail icon"
                    />
                    <a
                      className="link-red a-footer  "
                      href="mailto:help@hyperpure.com"
                    >
                      help@hyperpure.com
                    </a>
                  </div>
                </div>
              </div>

              <div className={styles.knowMore}>
                <div>
                  <div className="fs-14 w-600 mb-12px">Know More</div>
                  <div className="w-400 mb-12px">
                    <a
                      href={
                        apiEndpoint[API_HOST_HP] + "/z/corporate-announcements"
                      }
                      className="text-dark-blue footer-no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Corporate Announcements
                    </a>
                  </div>
                  <div className="w-400 mb-12px">
                    <a
                      href={apiEndpoint[API_HOST_HP] + "/z/governance"}
                      className="text-dark-blue footer-no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Governance
                    </a>
                  </div>
                  <div className="w-400 mb-12px">
                    <a
                      className="text-dark-blue footer-no-underline"
                      href="https://www.zomato.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy
                    </a>
                  </div>

                  <div className="w-400 mb-12px">
                    <Link
                      to={"/tnc/accepted"}
                      className="text-dark-blue footer-no-underline"
                    >
                      Terms of use
                    </Link>
                  </div>
                  <div className="w-400 mb-12px">
                    <a
                      className="text-dark-blue footer-no-underline"
                      href={
                        apiEndpoint[API_HOST_HP] +
                        "assets/pdf/supplier_code_of_conduct.pdf"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Supplier Code of Conduct
                    </a>
                  </div>
                  <div className="w-400">
                    <a
                      className="text-dark-blue footer-no-underline"
                      href="https://www.weatherunion.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Weather Union
                    </a>
                  </div>
                </div>
              </div>

              <div className={styles.followUs}>
                <div>
                  <div className="fs-14 w-600 mb-12px">Follow us on</div>
                  <div className={styles.socialIcons}>
                    <a
                      onClick={() =>
                        this.sendTrackingIdForSocialMedia("LINKEDIN")
                      }
                      className="text-dark-blue"
                      href="https://www.linkedin.com/company/hyperpurebyzomato/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        alt="Linkedin"
                        height={32}
                        width={32}
                        className={styles.socialIcon}
                        src={
                          apiEndpoint[API_HOST_HP] +
                          "/assets/images/linkedin_circle.png"
                        }
                      />
                    </a>
                    <a
                      onClick={() =>
                        this.sendTrackingIdForSocialMedia("INSTAGRAM")
                      }
                      className="text-dark-blue ml-2"
                      href="https://www.instagram.com/hyperpure_by_zomato/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        alt="Instagram"
                        height={32}
                        width={32}
                        className={styles.socialIcon}
                        src={
                          apiEndpoint[API_HOST_HP] +
                          "/assets/images/instagram_circle.png"
                        }
                      />
                    </a>
                    <a
                      onClick={() =>
                        this.sendTrackingIdForSocialMedia("YOUTUBE")
                      }
                      className="text-dark-blue ml-2"
                      href="https://www.youtube.com/@hyperpurebyzomato"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        alt="Youtube"
                        height={32}
                        width={32}
                        className={styles.socialIcon}
                        src={
                          apiEndpoint[API_HOST_HP] +
                          "/assets/images/youtube_circle.png"
                        }
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {!isMobScreenSize ? (
              <div className="column">
                <div className={styles.centerPos}>
                  <img
                    className={styles.hpIcon}
                    src="/logos/hplogo.svg"
                    alt="HP icon"
                  />
                </div>
                <div className={styles.centerPos}>
                  <img
                    src="/logos/logo_hp_black.png "
                    alt="Logo"
                    className={styles.hpTextIcon}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
